import { combineReducers, configureStore } from '@reduxjs/toolkit'
import apiSlice from '../services/api/slice'
import apiErroHander from '../services/api/error-handler'
import authSlice from '../services/auth/slice'
import appMenuSlice from '../components/app-menu/slice'
import usersSlice from '../features/users/slice'
import campaignsSlice from '../features/campaigns/slice'
import clientsSlice from '../features/clients/slice'
import prospectsSlice from '../features/prospects/slice'
import errorSlice from '../components/app-alert/slice'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

const persistConfig = {
  key: 'root',
  version: 1,
  storage: storageSession,
}

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  appMenu: appMenuSlice.reducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: {
    api: apiSlice.reducer,
    users: usersSlice.reducer,
    alert: errorSlice.reducer,
    campaigns: campaignsSlice.reducer,
    clients: clientsSlice.reducer,
    prospects: prospectsSlice.reducer,
    persisted: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware, apiErroHander),
})

export default store
